;(function () {
  const initCollapsibleContent = () => {
    const toggles = document.querySelectorAll('.collapsible-content__toggle')
    
    toggles.forEach((toggle) => {
      toggle.removeEventListener('click', handleToggleClick)
      toggle.addEventListener('click', handleToggleClick)
    })
  }

  const handleToggleClick = function (e) {
    e.preventDefault()
    
    const parent = this.closest('.collapsible-content__item')
    const answer = this.nextElementSibling
    
    // 找到答案元素（可能有其他元素在中间）
    let answerElement = answer
    while (answerElement && !answerElement.classList.contains('collapsible-content__answer')) {
      answerElement = answerElement.nextElementSibling
    }
    
    if (!answerElement) return
    
    if (!parent.classList.contains('active')) {
      // 关闭其他打开的项
      const siblings = parent.parentElement.querySelectorAll('.collapsible-content__item.active')
      siblings.forEach((sibling) => {
        if (sibling !== parent) {
          sibling.classList.remove('active')
          const siblingAnswer = sibling.querySelector('.collapsible-content__answer')
          if (siblingAnswer) {
            slideUp(siblingAnswer)
          }
        }
      })
      
      // 打开当前项
      parent.classList.add('active')
      slideDown(answerElement)
    } else {
      // 关闭当前项
      parent.classList.remove('active')
      slideUp(answerElement)
    }
  }

  const slideDown = (element) => {
    element.style.display = 'block'
    element.style.maxHeight = element.scrollHeight + 'px'
    element.style.overflow = 'hidden'
    element.style.transition = 'max-height 0.3s ease'
    
    setTimeout(() => {
      element.style.maxHeight = element.scrollHeight + 'px'
    }, 10)
  }

  const slideUp = (element) => {
    element.style.maxHeight = element.scrollHeight + 'px'
    element.style.overflow = 'hidden'
    element.style.transition = 'max-height 0.3s ease'
    
    setTimeout(() => {
      element.style.maxHeight = '0'
    }, 10)
    
    setTimeout(() => {
      element.style.display = 'none'
      element.style.maxHeight = ''
      element.style.overflow = ''
      element.style.transition = ''
    }, 300)
  }

  const handleResize = () => {
    const activeAnswers = document.querySelectorAll('.collapsible-content__item.active .collapsible-content__answer')
    activeAnswers.forEach((answer) => {
      answer.style.display = 'block'
      answer.style.maxHeight = answer.scrollHeight + 'px'
    })
  }

  window.addEventListener('resize', handleResize)

  document.addEventListener('shopify:section:load', function () {
    initCollapsibleContent()
    handleResize()
  })

  // 等待 DOM 完全加载后初始化
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCollapsibleContent)
  } else {
    initCollapsibleContent()
  }
  
  handleResize()
})()
